export const IMPACT_OF_DISABILITY_EVENT_NAMES = {
  COPIED_STATEMENT: 'Copied Impact Statement to Another Folder',
  REMOVED_STATEMENT: 'Removed Impact Statement from Library',
  SAVED_STATEMENT: 'Clicked Save Changes',
  VIEWED_LIBRARY_STATEMENT: 'Viewed Library Impact Statement',
  VIEWED_SHARED_STATEMENT: 'Viewed Shared Impact Statement'
}
